<template>
  <b-modal
    v-model="editorShown"
    centered
    size="md"
    no-close-on-backdrop
    header-bg-variant="primary"
    header-text-variant="white"
    header-class="bg-purple"
  >
    <template v-slot:modal-header>
      <div
        class="w-100 d-flex flex-row justify-content-between align-items-center"
      >
        <h5 class="modal-title">{{ formTitle }}</h5>
        <button
          type="button"
          aria-label="Close"
          class="close text-white"
          style="opacity: 1 !important"
          @click="$emit('onHidden')"
        >
          ×
        </button>
      </div>
    </template>
    <template v-slot:modal-footer>
      <div class="text-right mt-1 mr-2">
        <b-button @click="$emit('onHidden')" variant="secondary">
          Cancel
        </b-button>
        <b-button
          v-if="!belongsToRecurrence"
          class="ml-2"
          @click="submitAvailability"
          variant="primary"
        >
          Save
        </b-button>
        <b-button
          v-if="belongsToRecurrence"
          class="ml-2"
          @click="showRecurringEventModal"
          variant="primary"
        >
          Save
        </b-button>
      </div>
    </template>
    <b-form-group
      label=""
      :state="formErrors.user.length == 0 ? null : false"
      :invalid-feedback="formErrors.user.join(', ')"
    >
      <span
        >Provider:
        {{ formatUser(this.providerAvailabilityDefaultData.provider) }}</span
      >
    </b-form-group>
    <b-form-group
      label=""
      :state="formErrors.services.value < 0 ? true : false"
      :invalid-feedback="formErrors.services.join('. ')"
    >
      <div class="row">
        <div class="col-6 text-left mb-2">Services</div>
        <div class="col-6 text-right mb-2">
          <b-link
            :disabled="form.services.length == services.length"
            href="#"
            @click="allServicesChangeState"
            >Assign all Services</b-link
          >
        </div>
      </div>
      <multiple-select-unit-rate
        hideUnits
        hideMods
        v-model="form.services"
        :options="services"
        :no-cached="this.noCached"
      />
    </b-form-group>
    <b-form-group
      :state="formErrors.placesOfService.value < 0 ? true : false"
      :invalid-feedback="formErrors.placesOfService.join('. ')"
    >
      <template v-slot:label>
        Place of Service <span class="text-danger">*</span>
      </template>
      <multiple-select
        v-model="form.placesOfService"
        :options="placesOfService"
      />
    </b-form-group>
    <b-form-group
      label="Date, start time and end time."
      :state="formErrors.dateTimeDuration.length == 0 ? null : false"
      :invalid-feedback="formErrors.dateTimeDuration.join(', ')"
    >
      <date-time-range-picker
        v-model="selectedDateTimeDuration"
        :dateDisabledFn="datesNonWorking"
        :showAllDay="false"
      />
    </b-form-group>
    <b-form-group class="mt-2">
      <div class="d-flex flex-column">
        <div class="d-flex align-items-center">
          <vue-toggles
            @click="form.isRecurrent = !form.isRecurrent"
            :value="form.isRecurrent"
            height="30"
            width="50"
            checkedBg="#34C759"
            uncheckedBg="#FF6161"
          />
          <span class="ml-2">Make availability recurrent</span>
        </div>
      </div>
    </b-form-group>
    <b-form-group v-show="form.isRecurrent" class="position-relative">
      <recurrence-control
        v-model="form.recurrence"
        :startDate="startDateTime"
        :formErrors="formErrors.recurrence"
      />
    </b-form-group>
    <b-modal
      title="Edit recurring availability"
      header-bg-variant="primary"
      header-text-variant="white"
      size="md"
      no-close-on-backdrop
      centered
      ref="form-modal"
      @ok="e => submitAvailability(e, selectedOption)"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <div class="text-right mt-1 mr-2">
          <b-button @click="cancel()" variant="secondary">
            Cancel
          </b-button>
          <b-button class="ml-2" @click="ok()" variant="primary">
            Confirm
          </b-button>
        </div>
      </template>
      <b-form-group v-slot="{ ariaDescribedby }">
        <b-form-radio-group
          :options="options"
          v-model="selectedOption"
          :aria-describedby="ariaDescribedby"
          name="some-radios"
          stacked
        ></b-form-radio-group>
      </b-form-group>
    </b-modal>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import providerAvailabilityServer from "../../server/providerAvailability";
import userServer from "../../server/user";
import serviceServer from "../../server/service";
import { validateRequired, validateDate } from "../../helpers/validation";
import DateTimeRangePicker from "../controls/DateTimeRangePicker.vue";
import MultipleSelectUnitRate from "../controls/MultipleSelectUnitRate.vue";

import RecurrenceControl from "../controls/RecurrenceControl.vue";
import moment from "moment";
import MultipleSelect from "../controls/MultipleSelect.vue";

export default {
  name: "ProviderAvailabilityAddEditModal",
  components: {
    DateTimeRangePicker,
    RecurrenceControl,
    MultipleSelectUnitRate,
    MultipleSelect
  },
  props: ["providerAvailabilityId", "providerAvailabilityDefaultData"],
  data() {
    return {
      form: {
        user: null,
        dateTimeDuration: null,
        services: [],
        isRecurrent: false,
        recurrence: {
          frequencyNumber: 1,
          frequencyUnit: "Days",
          monthlyRepeat: null,
          endType: "ByOccurrences",
          endDate: null,
          occurrences: 10,
          sunday: false,
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          saturday: false
        },
        placesOfService: []
      },
      formErrors: {
        user: [],
        dateTimeDuration: [],
        services: [],
        recurrence: {
          ends: [],
          weekDay: []
        },
        placesOfService: []
      },
      users: [],
      placeOfServiceOptions: [],
      services: [],
      noCached: false,
      servicesAll: [],
      usersAll: [],
      options: [
        { value: "ModifySingleAvailability", text: "This availability" },
        {
          value: "ModifyAvailabilityAndRecurrence",
          text: "This and following availabilities"
        },
        { value: "ModifyRecurrence", text: "All availabilities" }
      ],
      selectedOption: "ModifySingleAvailability"
    };
  },
  async mounted() {
    await this.fetchUsers();
    await this.fetchServices();
    await this.fetchPlacesOfService();
    if (this.providerAvailabilityId) {
      const availability = await providerAvailabilityServer.get(
        this.providerAvailabilityId
      );
      this.form = {
        user: availability.provider
          ? {
              value: availability.provider.id,
              label: availability.provider.fullName,
              data: availability.provider
            }
          : null,
        dateTimeDuration: {
          date: this.formatDateOnlyMysql(availability.startDateTime),
          sTime: availability.allDay
            ? "00:00:00"
            : this.formatTimeOnlyMysql(availability.startDateTime),
          eTime: availability.allDay
            ? "00:00:00"
            : this.formatTimeOnlyMysql(availability.endDateTime),
          allDay: !!availability.allDay
        },
        services: availability.services
          ? availability.services.map(service => ({
              value: service.id,
              label: `${
                service.billingCodes[0]
                  ? service.billingCodes[0].cptCode + " - "
                  : ""
              } ${service.name}`,
              data: service
            }))
          : [],
        isRecurrent: availability.recurrence ? true : false,
        recurrence: {
          id: availability.recurrence ? availability.recurrence.id : null,
          frequencyNumber: availability.recurrence
            ? availability.recurrence.frequencyNumber
            : 1,
          frequencyUnit: availability.recurrence
            ? availability.recurrence.frequencyUnit
            : "Days",
          monthlyRepeat: availability.recurrence
            ? availability.recurrence.monthlyRepeat
            : null,
          endType: availability.recurrence
            ? availability.recurrence.endType
            : "ByOccurrences",
          endDate: availability.recurrence
            ? availability.recurrence.endDate
            : null,
          occurrences: availability.recurrence
            ? availability.recurrence.occurrences
            : 10,
          sunday: availability.recurrence
            ? availability.recurrence.sunday
            : false,
          monday: availability.recurrence
            ? availability.recurrence.monday
            : false,
          tuesday: availability.recurrence
            ? availability.recurrence.tuesday
            : false,
          wednesday: availability.recurrence
            ? availability.recurrence.wednesday
            : false,
          thursday: availability.recurrence
            ? availability.recurrence.thursday
            : false,
          friday: availability.recurrence
            ? availability.recurrence.friday
            : false,
          saturday: availability.recurrence
            ? availability.recurrence.saturday
            : false
        },
        placesOfService: availability.placesOfService
          ? availability.placesOfService.map(placeOfService => ({
              value: placeOfService.id,
              label: `${placeOfService.name}`,
              data: placeOfService
            }))
          : []
      };
    } else if (
      this.providerAvailabilityDefaultData &&
      this.providerAvailabilityDefaultData.startDateTime
    ) {
      const availability = this.providerAvailabilityDefaultData;
      this.form = {
        user: availability.provider
          ? {
              value: availability.provider.id,
              label: availability.provider.fullName,
              data: availability.provider
            }
          : null,
        dateTimeDuration: {
          date: this.formatDateOnlyMysql(
            availability.data?.startDate || availability.startDateTime
          ),
          sTime: availability.data?.allDay
            ? "00:00:00"
            : this.formatTimeOnlyMysql(
                availability.data?.startDate || availability.startDateTime
              ),
          eTime: availability.data?.allDay
            ? "00:00:00"
            : this.formatTimeOnlyMysql(
                availability.data?.endDate || availability.endDateTime
              ),
          allDay: !!availability.data?.allDay
        },
        services: availability.services
          ? availability.services.map(service => ({
              value: service.id,
              label: `${service.billingCodes[0].cptCode} - ${service.name}`,
              data: service
            }))
          : [],
        isRecurrent: false,
        recurrence: {
          frequencyNumber: 1,
          frequencyUnit: "Days",
          monthlyRepeat: "ByDayOfMonth",
          endType: "ByOccurrences",
          endDate: null,
          occurrences: 10,
          sunday: false,
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          saturday: false
        },
        placesOfService: []
      };
    } else {
      const availability = this.providerAvailabilityDefaultData;
      this.form.dateTimeDuration = {
        date: null,
        sTime: null,
        eTime: null,
        allDay: false
      };
      this.form.user = availability.provider
        ? {
            value: availability.provider.id,
            label: availability.provider.fullName,
            data: availability.provider
          }
        : null;
    }
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess", "showAlertError"]),
    ...mapActions("client", ["fetchPlacesOfService"]),
    validateAvailabilitySubmit() {
      let withoutErrors = true;

      this.formErrors.dateTimeDuration = [];
      if (
        !validateRequired(this.form.dateTimeDuration.date) ||
        (!this.form.dateTimeDuration.allDay &&
          (!validateRequired(this.form.dateTimeDuration.sTime) ||
            !validateRequired(this.form.dateTimeDuration.eTime)))
      ) {
        this.formErrors.dateTimeDuration.push("This field is required");
        withoutErrors = false;
      } else if (!validateDate(this.form.dateTimeDuration.date)) {
        this.formErrors.dateTimeDuration.push("Invalid date");
        withoutErrors = false;
      } else if (
        this.datesNonWorking(
          null,
          new Date(this.form.dateTimeDuration.date + " 00:00:00")
        ) ||
        (!this.form.dateTimeDuration.allDay &&
          (this.form.dateTimeDuration.sTime <
            this.selectedLocation.operationStarts ||
            this.form.dateTimeDuration.sTime >
              this.selectedLocation.operationEnds)) ||
          this.form.dateTimeDuration.eTime > this.selectedLocation.operationEnds
      ) {
        this.formErrors.dateTimeDuration.push(
          "Events cannot be created outside hours of operation"
        );
        withoutErrors = false;
      }

      if (!this.isValidEndTimeDuration()) {
        this.formErrors.dateTimeDuration.push("Invalid end time");
        withoutErrors = false;
      }

      this.formErrors.recurrence.ends = [];
      if (
        this.form.recurrence.endType == "ByDate" &&
        !validateRequired(this.form.recurrence.endDate)
      ) {
        this.formErrors.recurrence.ends.push(
          "You must specify a date to end the recurrence"
        );
        withoutErrors = false;
      } else if (
        this.form.recurrence.endType == "ByDate" &&
        this.form.recurrence.endDate < this.form.dateTimeDuration.date
      ) {
        this.formErrors.recurrence.ends.push(
          "Recurrence end date must be greater than start date"
        );
        withoutErrors = false;
      }

      this.formErrors.recurrence.weekDay = [];
      if (
        this.form.isRecurrent == true &&
        this.form.recurrence.frequencyUnit == "Weeks" &&
        this.form.recurrence.sunday == false &&
        this.form.recurrence.monday == false &&
        this.form.recurrence.tuesday == false &&
        this.form.recurrence.wednesday == false &&
        this.form.recurrence.thursday == false &&
        this.form.recurrence.friday == false &&
        this.form.recurrence.saturday == false
      ) {
        this.formErrors.recurrence.weekDay.push(
          "You must specify at least one day of the week to continue with the recurrence"
        );
        withoutErrors = false;

        return withoutErrors;
      }

      this.formErrors.placesOfService = [];
      if (!validateRequired(this.form.placesOfService)) {
        this.formErrors.placesOfService.push("This field is required");
        withoutErrors = false;
      }
      return withoutErrors;
    },
    isValidEndTimeDuration() {
      return Date.parse(this.startDateTime) < Date.parse(this.endDateTime);
    },
    async submitAvailability(
      modalEvent,
      modificationType = "ModifySingleAvailability"
    ) {
      modalEvent.preventDefault();
      const result = this.validateAvailabilitySubmit();
      if (result) {
        const formData = {
          providerId: this.providerAvailabilityDefaultData.provider.id,
          placesOfService: this.form.placesOfService.map(
            placeOfService => placeOfService.value
          ),
          users: this.form.user ? [this.form.user.value] : [],
          allDay: this.form.dateTimeDuration.allDay,
          startDateTime: this.startDateTime,
          endDateTime: this.endDateTime,
          modification: modificationType,
          services: this.form.services.map(service => service.value),
          ...(this.form.isRecurrent && {
            recurrence: {
              id: this.form.recurrence.id,
              frequencyNumber: this.form.recurrence.frequencyNumber,
              frequencyUnit: this.form.recurrence.frequencyUnit,
              endType: this.form.recurrence.endType,
              ...(this.form.recurrence.endType == "ByDate" && {
                endDate: this.formatEndDateSql(
                  moment(this.form.recurrence.endDate).format("YYYY-MM-DD")
                )
              }),
              ...(this.form.recurrence.endType == "ByOccurrences" && {
                occurrences: this.form.recurrence.occurrences
              }),
              ...(this.form.recurrence.frequencyUnit == "Months" && {
                monthlyRepeat: this.form.recurrence.monthlyRepeat
              }),
              ...(this.form.recurrence.frequencyUnit == "Weeks" && {
                sunday: this.form.recurrence.sunday,
                monday: this.form.recurrence.monday,
                tuesday: this.form.recurrence.tuesday,
                wednesday: this.form.recurrence.wednesday,
                thursday: this.form.recurrence.thursday,
                friday: this.form.recurrence.friday,
                saturday: this.form.recurrence.saturday
              })
            }
          })
        };
        if (this.providerAvailabilityId) {
          try {
            await providerAvailabilityServer.update(
              this.providerAvailabilityId,
              formData
            );
          } catch (error) {
            if (error.response.data.errorCode === "tooMuchOcurrences") {
              this.showAlertError({
                message:
                  "The amount of events to generate is too big (max 300). Please modify the parameters and try again."
              });
            } else {
              this.showAlertError({
                message: error.message
              });
            }
            return;
          }
        } else {
          try {
            await providerAvailabilityServer.create(formData);
          } catch (error) {
            if (error.response.data.errorCode === "tooMuchOcurrences") {
              this.showAlertError({
                message:
                  "The amount of events to generate is too big (max 300). Please modify the parameters and try again."
              });
            } else {
              this.showAlertError({
                message: error.message
              });
            }
            return;
          }
        }
        this.showAlertSuccess();
        this.$emit("onModify");
      }
    },
    async fetchUsers() {
      const users = await userServer.getUserServices();
      this.usersAll = users
        .filter(user => user.providerInfo)
        .map(user => ({
          value: user.id,
          label: this.formatUser(user),
          data: user
        }));
      this.users = this.usersAll;
    },
    async fetchServices() {
      const services = await serviceServer.query({
        type: "Service"
      });
      this.servicesAll = services.map(service => ({
        value: service.id,
        label: `${
          service.billingCodes[0] ? service.billingCodes[0].cptCode + " - " : ""
        } ${service.name}`,
        data: service
      }));
      var defaultProvider = this.providerAvailabilityDefaultData.provider;
      this.services =
        defaultProvider && defaultProvider.services
          ? this.servicesAll.filter(s => {
              const defaultProvidedServices = defaultProvider.services.map(
                service => {
                  if (service.id) {
                    return service;
                  } else {
                    return {
                      id: service
                    };
                  }
                }
              );
              return defaultProvidedServices.some(p => p.id === s.value);
            })
          : [];
    },
    allServicesChangeState() {
      this.services.forEach(s => {
        const exists = this.form.services.find(x => x.value == s.value);
        if (!exists) {
          this.form.services.push(s);
        }
      });
    },
    async showRecurringEventModal() {
      this.$refs["form-modal"].show();
    }
  },
  computed: {
    ...mapGetters("layout", ["datesNonWorking", "getCurrentAdjustedDateTime"]),
    ...mapGetters("client", ["selectedLocation"]),
    ...mapState("client", {
      placesOfService: state =>
        state.placesOfService.map(placeOfService => ({
          value: placeOfService.id,
          label: `${placeOfService.code}-${placeOfService.name}`,
          data: placeOfService
        }))
    }),
    providerUsers() {
      return this.users.filter(u => u.data.providerInfo);
    },
    startDateTime() {
      if (!this.form.dateTimeDuration) {
        return null;
      }
      if (!this.form.dateTimeDuration.date) {
        return null;
      }
      if (
        !this.form.dateTimeDuration.sTime &&
        !this.form.dateTimeDuration.eTime &&
        !this.form.dateTimeDuration.allDay
      ) {
        return null;
      }

      const dateTime = `${this.form.dateTimeDuration.date} ${
        this.form.dateTimeDuration.allDay
          ? "00:00:00"
          : this.form.dateTimeDuration.sTime
      }`;

      return this.formatDateTimeSql(dateTime);
    },
    endDateTime() {
      if (!this.form.dateTimeDuration) {
        return null;
      }
      if (!this.form.dateTimeDuration.date) {
        return null;
      }
      if (
        !this.form.dateTimeDuration.eTime ||
        this.form.dateTimeDuration.allDay
      ) {
        return null;
      }

      const dateTime = `${this.form.dateTimeDuration.date} ${
        this.form.dateTimeDuration.allDay
          ? "00:00:00"
          : this.form.dateTimeDuration.eTime
      }`;

      return this.formatDateTimeSql(dateTime);
    },
    belongsToRecurrence() {
      return !!this.form.recurrence?.id;
    },
    formTitle() {
      if (this.providerAvailabilityId) {
        return this.belongsToRecurrence
          ? "Edit recurrent availability"
          : "Edit availability";
      } else {
        return (
          "Add availability for " +
          this.formatUser(this.providerAvailabilityDefaultData.provider)
        );
      }
    },
    selectedDateTimeDuration: {
      get() {
        return this.form.dateTimeDuration;
      },
      async set(newValue) {
        this.form.dateTimeDuration = newValue;
      }
    },
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  watch: {
    "form.user": {
      handler: async function(value) {
        if (!value) return;
        if (value) {
          const currentUserServices = this.users.find(
            user => user.value == value.value
          );
          this.services = this.servicesAll.filter(s =>
            currentUserServices.data.services?.includes(s.value)
          );
          this.noCached = true;
        } else {
          this.services = this.servicesAll;
          this.noCached = false;
          if (this.form.services.length > 0) {
            this.form.services = [];
            this.formErrors.services = [];
          }
        }
      },
      deep: true
    },
    "form.services": {
      handler: async function(value) {
        if (value && value.length > 0) {
          let servicesId = this.form.services.map(s => s.value);
          this.users = this.usersAll.filter(u =>
            servicesId.every(s => u.data.services?.includes(s))
          );
        } else {
          this.users = this.usersAll;
        }
      },
      deep: true
    }
  }
};
</script>
